<template>
  <b-container>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" style="font-size: 0.875rem">
          <router-link to="/dashboard">Home</router-link>
        </li>
        <li class="breadcrumb-item" style="font-size: 0.875rem">
          <router-link to="/dashboard">Guard Registration</router-link>
        </li>
        <li
          class="breadcrumb-item active"
          style="font-size: 0.875rem"
          aria-current="page"
        >
          Police/Medical Verification List
        </li>
      </ol>
    </nav>

    <Policeverification-filter
      v-model="form"
      :boards="boards"
      :approvalStatus="approvalStatus"
      :events="events"
      :name="Applications_name"
      :RoleID="RoleID"
      @submit="onSubmit"
      @reset="onReset"
    ></Policeverification-filter>

    <hr />

    <b-row class="mb-2">
      <b-col md="3">
        <b-input-group>
          <b-form-input
            v-model="filter"
            placeholder="Type to Search"
            size="sm"
          />
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''" size="sm"
              >Clear</b-btn
            >
          </b-input-group-append>
        </b-input-group>
      </b-col>

      <b-col md="3">
        <p>Total Records: {{ Total }}</p>
      </b-col>
      <b-col>
        <b-button
          v-if="RoleID == 99"
          class="float-right mx-3"
          variant="outline-danger"
          size="sm"
          @click="convertToPdf1"
          style="float: right; font-size: 1em; font-color: red"
        >
          <i class="fa fa-file-pdf"></i>
        </b-button>
      </b-col>
    </b-row>
    <loading
      :active.sync="isLoading"
      color="#5dbbda"
      loader="spinner"
      :is-full-page="fullPage"
      width:2
      height:2
    ></loading>

    <b-table
      id="tblApplication"
      show-empty
      select-mode="multi"
      head-variant="dark"
      empty-text="No Data available."
      stacked="md"
      bordered
      striped
      :items="applications"
      :fields="fields"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @filtered="onFiltered"
      style="font-size: 12px"
    >
      <template v-slot:cell(sr_no)="row">{{
        (currentPage - 1) * perPage + row.index + 1
      }}</template>
      <template v-slot:cell(Applicant)="row">
        <span v-if="row.item.EventDetails">
          {{ jsonconverter(row.item.EventDetails) }}
        </span>
      </template>
     <template v-slot:cell(actions)="row">
  <b-button
    v-if="StatusName == 'Pending'"
    size="sm"
    @click.stop="viewProfile(row.item)"
    class="mr-1 pt-0 pb-0"
    variant="success"
  >
    <i>Verify</i>
  </b-button>
  <b-button
    v-else
    size="sm"
    @click.stop="view(row.item)"
    class="mr-1 pt-0 pb-0"
    variant="success"
  >
    <i>View</i>
  </b-button>
</template>

    
    </b-table>
    <b-row>
      <b-col md="8" class="my-1">
        <b-pagination
          :total-rows="Total"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
          size="sm"
          @change="ChangeEvent"
        />
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group
          horizontal
          label="Per page"
          class="mb-0"
          label-size="sm"
          :label-cols="6"
        >
          <b-form-select
            :options="pageOptions"
            v-model="perPage"
            size="sm"
            @change="ChangeEventPage"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as _ from "lodash";
import Spinner from "vue-simple-spinner";
import Formatter from "@/Formatter";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import XLSX from "xlsx";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import PoliceverificationFilter from "@/components/PoliceverificationFilter.vue";

export default {
  props: ["userBoardID", "userApprovalStatus", "userPoolType", "value"],
  components: { Spinner, PoliceverificationFilter, DatePicker, Loading },
  data() {
    return {
      form: this.value || {},
      entry_date: "",
      showBtn: false,
      BatchNumber: "",
      show: false,
      showsts: false,
      showExtend: false,
      modalInfo: "",
      EventID: "",
      boards: this.$store.getters.getBoards,
      events: this.$store.getters.getEvents,
      download_applications: [],
      approvalStatus: this.$store.getters.getApprovalStatus,
      applications: [],
      bscReport: "",
      bscReportPath: "",
      appCount: 0,
      appDate: null,
      attendence_applications: [],

      fields: [
        { key: "sr_no", label: "SrNo" },
        { key: "EventTitle", label: "Type" },
        { key: "ApplicationNo", label: "Application No" },

        { key: "FullName", label: "Applicant Name" },
        { key: "StatusName", label: "Status" },

        { key: "CreatedDate", label: "Created Date" },
        { key: "actions", label: "View" },
      ],
      marks_applications: [],
      selected: [],
      showbtn: false,
      selectedApplication: "",
      currentPage: 1,
      Applications_name: [{ name: "Applications" }],
      perPage: 5,
      Total: 0,
      pageOptions: [5, 10, 20, 50, 100, 200, 500, 1000],
      sortBy: null,
      sortDesc: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      fullPage: false,
      isLoadingFile: false,
      isAdmin: false,
      FullName: "",

      form: {
        BoardID: "",
        Status: null,
        RegType: null,
        StartDate: null,
        EndDate: null,
        Offset: 0,
        Limit: 50,
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    userBoard() {
      return this.$store.getters.getUserBoard;
    },
    RoleID() {
      var nme = this.$store.getters.loggedUser;
      return nme.RoleID;
      //alert(nme.RegistrationType);
    },
  },
  methods: {
    viewProfile(item) {
      //console.log(item)
      //alert(item.RegistrationID);
      this.$router.push({
        name: "ViewPoliceMedical",
        params: {
          appid: item.RegistrationID,
        },
      });
    },
     view(item) {
      //console.log(item)
      //alert(item.RegistrationID);
      this.$router.push({
        name: "ViewPoliceMedical",
        params: {
          appid: item.RegistrationID,
        },
      });
    },
    
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.Total = filteredItems.length;
      this.currentPage = 1;
    },
    jsonconverter(data) {
      var temp = JSON.parse(data);

      var FullName =
        temp.ApplicantDetails[0].FirstName +
        " " +
        temp.ApplicantDetails[0].MiddleName +
        " " +
        temp.ApplicantDetails[0].LastName;
      return FullName;
    },

    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    async downloadExcel() {
      var columns = [
        "Sr No",
        "Type",
        "Application No",
        "Applicant Name",
        "Status",
        "Created Date",
      ];

      let app_data = [];

      this.applications.forEach((element, index) => {
        let temp = JSON.parse(element.EventDetails);

        let obj = {
          "Sr No": index + 1,
          Type: temp.ApplicantDetails[0].EventTitle || "",
          "Application No": temp.ApplicantDetails[0].ApplicationNo || "",
          "Applicant Name": temp.ApplicantDetails[0].FullName || "",
          Status: temp.ApplicantDetails[0].StatusName || "",
          "Created Date": this.convertDateFormat(
            temp.ApplicantDetails[0].CreatedDate
          ),
        };

        app_data.push(obj);
      });

      let wb = XLSX.utils.book_new();
      let ws = XLSX.utils.json_to_sheet(app_data, { header: columns });

      ws["!cols"] = [
        { wpx: 80 }, // Sr No
        { wpx: 150 }, // Type
        { wpx: 150 }, // Application No
        { wpx: 180 }, // Applicant Name
        { wpx: 120 }, // Status
        { wpx: 180 }, // Created Date
      ];

      XLSX.utils.book_append_sheet(wb, ws, "Applications");
      XLSX.writeFile(wb, "Application.xlsx");
    },

    convertToPdf1() {
      var Total = this.Total ? this.Total.toString() : "0";
      var pdf = new jsPDF("l", "pt");

      for (var i = 0; i < this.applications.length; i++) {
        if (this.applications[i].EventDetails != null) {
          var temp = JSON.parse(this.applications[i].EventDetails);
          // this.applications[i].FullName = temp.ApplicantDetails[0].FirstName+' '+temp.ApplicantDetails[0].MiddleName+' '+temp.ApplicantDetails[0].LastName;
          this.applications[i].Mobile = temp.ApplicantDetails[0].Mobile;
          this.applications[i].DOB = temp.ApplicantDetails[0].DOB;
          this.applications[i].AadharNo = temp.ApplicantDetails[0].AadharNo;
          this.applications[i].Email = temp.ApplicantDetails[0].Email;
          this.applications[i].Remarks = temp.ApplicantDetails[0].Remarks;
        }
      }
      var columns = [
        { dataKey: "sr_no", title: "Sr No" },
        { dataKey: "RegistrationType", title: "Type" },
        // { dataKey: "FullName", title: "Applicant Name" },
        { dataKey: "DOB", title: "DOB" },
        { dataKey: "Mobile", title: "Mobile" },
        { dataKey: "Email", title: "Email" },
        { dataKey: "AadharNo", title: "Aadhar No" },
        { dataKey: "Remarks", title: "Remark" },
        { dataKey: "BoardAddProfileStatus", title: "Status" },
        { dataKey: "CreatedDate", title: "Created Date" },
      ];

      var boardname = "";
      this.$store.getters.getBoards.forEach((item) => {
        if (item.SecurityBoardID == this.$store.getters.getUserBoard) {
          boardname = item.SecurityBoardName;
        }
      });
      // var event = "";
      // this.$store.getters.getEvents.forEach((e) => {
      //   if (e.EventID == this.$store.getters.getAppSearchForm.EventID) {
      //     event = e.EventTitle;
      //     return;
      //   }
      // });
      var ref = this;
      var pageContent = function (data) {
        pdf.text(
          "Security Guards Board for Brihan Mumbai & Thane District ",
          pdf.internal.pageSize.getWidth() / 2,
          40,
          "center"
        );
        //  pdf.text(boardname, pdf.internal.pageSize.getWidth() / 2, 25, "center");
        pdf.text(
          "Sign Up List ",
          pdf.internal.pageSize.getWidth() / 2,
          60,
          "center"
        );
        pdf.setFontSize(12);
        pdf.text("Date :", 35, 70);
        pdf.text("Total Applications :", 610, 70);
        pdf.text(ref.convertDateFormat(new Date()), 70, 70);
        pdf.text(Total, 720, 70);
        pdf.page = 1;
        function footer() {
          pdf.text(
            "page " + pdf.page,
            pdf.internal.pageSize.getWidth() / 2,
            pdf.internal.pageSize.height - 10
          );
          pdf.page++;
        }
      };

      var start_y_pos = 80;
      var vc = this;
      pdf.autoTable(
        columns,
        vc.applications,
        {
          didDrawPage: pageContent,
          startY: start_y_pos,
          margin: { top: 80 },
        },
        {
          didParseCell(data) {},
        }
      );
      pdf.save("SignupList.pdf");
    },
    convertToPdf() {
      const Total = this.Total ? this.Total.toString() : "0";
      const pdf = new jsPDF("l", "pt");

      let rows = [];

      this.applications.forEach((app, index) => {
        if (app.EventDetails) {
          let temp = JSON.parse(app.EventDetails);
          let details = temp.ApplicantDetails[0];

          rows.push({
            sr_no: index + 1,
            Type: details.EventTitle || "",
            ApplicationNo: details.ApplicationNo || "",
            FullName: details.FullName || "",
            Status: details.StatusName || "",
            CreatedDate: this.convertDateFormat(details.CreatedDate),
          });
        }
      });

      const columns = [
        { dataKey: "sr_no", title: "Sr No" },
        { dataKey: "Type", title: "Type" },
        { dataKey: "ApplicationNo", title: "Application No" },
        { dataKey: "FullName", title: "Applicant Name" },
        { dataKey: "StatusName", title: "Status" },
        { dataKey: "CreatedDate", title: "Created Date" },
      ];

      let boardname = "";
      this.$store.getters.getBoards.forEach((item) => {
        if (item.SecurityBoardID == this.$store.getters.getUserBoard) {
          boardname = item.SecurityBoardName;
        }
      });

      const pageContent = (data) => {
        pdf.setFontSize(14);
        pdf.text(boardname, pdf.internal.pageSize.getWidth() / 2, 25, {
          align: "center",
        });
        pdf.setFontSize(13);
        pdf.text(
          "Police Verification List",
          pdf.internal.pageSize.getWidth() / 2,
          50,
          { align: "center" }
        );

        pdf.setFontSize(10);
        pdf.text("Date: " + this.convertDateFormat(new Date()), 35, 70);
        pdf.text("Total Applications: " + Total, 610, 70);

        // Footer (optional per page)
        let str = "Page " + pdf.internal.getNumberOfPages();
        pdf.setFontSize(10);
        pdf.text(
          str,
          pdf.internal.pageSize.getWidth() / 2,
          pdf.internal.pageSize.getHeight() - 10,
          {
            align: "center",
          }
        );
      };

      pdf.autoTable({
        columns: columns,
        body: rows,
        startY: 80,
        didDrawPage: pageContent,
        margin: { top: 80 },
        styles: { fontSize: 9, cellPadding: 4 },
        headStyles: { fillColor: [60, 141, 188] },
      });

      pdf.save("SignupList.pdf");
    },

    convertDateFormatYMD(inDate) {
      if (inDate) {
        return Formatter.convertDateFormatYMD(inDate);
      }
    },

    onSubmit() {
      if (
        this.form.entry_date &&
        this.form.entry_date.length > 0 &&
        this.form.entry_date[0] == null &&
        this.form.entry_date[1] == null
      ) {
        this.$delete(this.form, "StartDate");
        this.$delete(this.form, "EndDate");
        this.$delete(this.form, "entry_date");
      } else if (
        this.form.entry_date &&
        this.form.entry_date.length > 0 &&
        this.form.entry_date[0] != "1970-01-1"
      ) {
        this.form.StartDate = Formatter.convertDateFormatYMD(
          this.form.entry_date[0]
        );
        this.form.EndDate = Formatter.convertDateFormatYMD(
          this.form.entry_date[1]
        );
      }
      this.form.Limit = this.perPage;
      this.form.OffSet = 0;
      //this.$delete(this.form, 'entry_date');

      this.$store.dispatch("setSearchForm", this.form);
      this.getlist(1);
    },
    onReset() {
      if (
        this.form.entry_date &&
        this.form.entry_date.length > 0 &&
        this.form.entry_date[0] == null &&
        this.form.entry_date[1] == null
      ) {
        // this.form.StartDate = null;
        // this.form.EndDate = null;
        this.$delete(this.form, "StartDate");
        this.$delete(this.form, "EndDate");
        this.$delete(this.form, "entry_date");
      }
      this.$delete(this.form, "ApplicantName");
      this.$delete(this.form, "RecordStatus");
      this.$delete(this.form, "EventID");
      this.getlist(1);
    },
    ChangeEvent(evt) {
      this.currentPage = evt;
      this.form.Limit = this.perPage;
      this.form.OffSet = (this.currentPage - 1) * this.perPage;
      this.getlist(1);
    },

    ChangeEventPage(evt) {
      this.perPage = evt;
      this.currentPage = 1;
      this.form.Limit = this.perPage;
      this.form.OffSet = 0;
      this.getlist(1);
    },

    getlist(flag) {
      var payload = {
        BoardID: this.form.BoardID,
        //Status: this.form.Status,
        //RegType: this.form.RegType,
        //StartDate: this.form.StartDate,
        //EndDate: this.form.EndDate,
        Offset: this.form.Offset || 0,
        Limit: this.form.Limit || 50,
        //EventID:this.form.EventID
      };

      console.log("Sending payload:", payload);

      apis
        .ReadpoliceVerilist(payload)
        .then((response) => {
          if (response.status === 200) {
            this.applications = response.body.Data || [];
            this.applications.forEach((app, i) => (app.sr_no = i + 1));
            this.Total = response.body.TotalRecords || 0;
          }
        })
        .catch((err) => {
          console.error("API error:", err);
        });
    },
  },
  mounted() {
    this.form.BoardID = this.userBoard;
    this.BoardID = this.userBoard;
    if (this.$route.params.BoardID) {
      this.form.BoardID = this.$route.params.BoardID;
      this.BoardID = this.$route.params.BoardID;
    }

    let frm = this.$store.getters.getAppSearchForm;

    this.selectValue = [];

    if (frm != {} && frm.EventID != undefined) {
      this.form = frm;
      this.getlist(1);
    }
     this.getlist(1);
  },
};
</script>
<style scoped>
.autowidth {
  width: 300px !important;
  text-align: left;
}
</style>
